import React from 'react';
import './Testimonials.css';
import Slider from "react-slick";
import client from "../../images/1 (1).jpg";



const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false
};


const Testimonials = () => {
    return (
        <div className='pt-28 overflow-x-hidden' id='testimonials'>

            <div className="container mx-auto pb-20">
                <div className='text-center space-y-8'>
                    <h4 data-aos="fade-down" className='uppercase text-lg text-white font-thin tracking-[6px]'>Testimonials</h4>
                    <h2 data-aos="fade-up" className='text-4xl md:text-6xl color-font'>We love our clients from all <br /> over the world.</h2>
                </div>
            </div>

            <div className='w-full lg:w-[80vw] xl:w-[50vw] mx-auto pb-28'>
                <div data-aos="zoom-in" data-aos-easing="ease-out-cubic" className='slider-bg'>
                    <Slider {...settings}>

                        <div className=''>
                            <div className='flex flex-col sm:flex-row items-center p-10 pb-12 sm:space-x-10 bg-black/30 backdrop-blur-lg rounded'>
                                <div className='text-center border-b sm:border-b-0 sm:border-r border-dashed border-neutral-content sm:pr-10 pb-5 sm:pb-0 space-y-5'>
                                    <div className='bg-gradient-to-r from-neutral-content rounded-full p-1 mx-auto w-44 h-44'>
                                        <img src={client} className="w-full h-full rounded-full" alt="" />
                                    </div>
                                    <div>
                                        <p className='text-lg color-font'>Michale Jackson</p>
                                        <p>Co Founder</p>
                                    </div>
                                </div>
                                <div className='text-center sm:text-left pt-5 sm:pt-0'>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus, accusantium expedita. Sapiente vel molestias voluptates, expedita minima adipisci esse doloribus error molestiae in! Tenetur quia dicta dignissimos error, quae nulla?</p>
                                </div>
                            </div>
                        </div>

                        <div className=''>
                            <div className='flex flex-col sm:flex-row items-center p-10 pb-12 sm:space-x-10 bg-black/30 backdrop-blur-lg rounded'>
                                <div className='text-center border-b sm:border-b-0 sm:border-r border-dashed border-neutral-content sm:pr-10 pb-5 sm:pb-0 space-y-5'>
                                    <div className='bg-gradient-to-r from-neutral-content rounded-full p-1 mx-auto w-44 h-44'>
                                        <img src={client} className="w-full h-full rounded-full" alt="" />
                                    </div>
                                    <div>
                                        <p className='text-lg color-font'>Michale Jackson</p>
                                        <p>Co Founder</p>
                                    </div>
                                </div>
                                <div className='text-center sm:text-left pt-5 sm:pt-0'>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus, accusantium expedita. Sapiente vel molestias voluptates, expedita minima adipisci esse doloribus error molestiae in! Tenetur quia dicta dignissimos error, quae nulla?</p>
                                </div>
                            </div>
                        </div>

                        <div className=''>
                            <div className='flex flex-col sm:flex-row items-center p-10 pb-12 sm:space-x-10 bg-black/30 backdrop-blur-lg rounded'>
                                <div className='text-center border-b sm:border-b-0 sm:border-r border-dashed border-neutral-content sm:pr-10 pb-5 sm:pb-0 space-y-5'>
                                    <div className='bg-gradient-to-r from-neutral-content rounded-full p-1 mx-auto w-44 h-44'>
                                        <img src={client} className="w-full h-full rounded-full" alt="" />
                                    </div>
                                    <div>
                                        <p className='text-lg color-font'>Michale Jackson</p>
                                        <p>Co Founder</p>
                                    </div>
                                </div>
                                <div className='text-center sm:text-left pt-5 sm:pt-0'>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus, accusantium expedita. Sapiente vel molestias voluptates, expedita minima adipisci esse doloribus error molestiae in! Tenetur quia dicta dignissimos error, quae nulla?</p>
                                </div>
                            </div>
                        </div>

                        




                    </Slider>
                </div>
            </div>

            <div className="w-3/5 h-1 bg-gradient-to-r from-neutral-content z-50"></div>


        </div>
    );
};

export default Testimonials;